import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataSourcesService } from "./data-sources.service";

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private http: HttpClient,
    private dataSourceService: DataSourcesService) { }

  getAllCountries() {
    return this.http.get('/countries/get-all-countries');
  }

  getBillingCountries(apiId){
      const data = {
        CAM_DOM_ID:104123,
        CAM_APP_ID:406,
        IsOld:false
      }
      return this.dataSourceService.invokeDataSource(apiId , data );

  }
  getBillingCities(apiId: any){
    const data = {
      CRG_CNT_CODE:`sa`,
      CITY_TYPE:1
    }
    return this.dataSourceService.invokeDataSource(apiId , data );

  }

}
